export default function CompanyResults() {
  const results = [
    { icon: 'ri-line-chart-line', title: 'Рост конверсии', desc: 'Конверсия в сделку растёт на 15–25% за счёт точного попадания в потребность клиента' },
    { icon: 'ri-user-heart-line', title: 'Лучшее понимание клиента', desc: 'Менеджеры слышат истинные мотивы, а не поверхностные запросы' },
    { icon: 'ri-chat-check-line', title: 'Меньше возражений', desc: 'Качественная диагностика снимает большинство возражений до их появления' },
    { icon: 'ri-funds-line', title: 'Рост среднего чека', desc: 'Когда потребность раскрыта глубоко, клиент готов платить за полное решение' },
    { icon: 'ri-hand-heart-line', title: 'Рост доверия', desc: 'Клиент видит эксперта, который понимает его бизнес — не продавца' },
    { icon: 'ri-percent-line', title: 'Меньше скидок', desc: 'Цена отходит на второй план, когда ценность предложения очевидна' },
    { icon: 'ri-star-line', title: 'Качественные переговоры', desc: 'Разговоры становятся глубже и конструктивнее с обеих сторон' },
    { icon: 'ri-file-list-3-line', title: 'Единый стандарт общения', desc: 'Все менеджеры работают по единой структуре диагностики' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Что получает компания
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Измеримые бизнес-показатели, которые меняются после внедрения программы выявления потребностей.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {results.map((item, i) => (
            <div key={i} className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl p-5 md:p-6 text-white hover:shadow-lg transition-shadow group">
              <div className="w-12 h-12 bg-white/15 rounded-xl flex items-center justify-center flex-shrink-0 mb-4">
                <i className={`${item.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-white mb-2">{item.title}</h3>
              <p className="text-sm text-white/80 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}